import { Link } from "@tanstack/react-router";
import { Button, Result } from "antd";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";

export const NotFound = () => {
    const { t } = usePaldockTranslation("tables.ui.not-found");
    const { t: tC } = usePaldockTranslation("common");
    return (
        <div className={"mx-auto my-auto"}>
            <Result
                status="404"
                title="404"
                subTitle={t("subtitle")}
                extra={
                    <Link to={"/"}>
                        <Button type="primary">{tC("go_back")}</Button>
                    </Link>
                }
            />
        </div>
    );
};
